import { useEffect, useState } from 'react'

import { useApolloClient } from '@apollo/client'

import {
  GetCheckoutSessionSecretResponse,
  GetCheckoutSessionSecretRequest,
  GET_CHECKOUT_SESSION_SECRET,
} from 'src/lib/hooks/stripe/usePurchaseItList'
import { useSetLocation } from 'src/lib/hooks/useSetLocation'

import { redirectToItList } from '..'

export default function useActivateItList(itListId: number) {
  const client = useApolloClient()
  const [isActivated, setIsActivated] = useState(false)
  const resetQueryParams = useResetQueryParams()

  const activateItList = async () => {
    const { error } = await client.query<
      GetCheckoutSessionSecretResponse,
      GetCheckoutSessionSecretRequest
    >({
      query: GET_CHECKOUT_SESSION_SECRET,
      variables: {
        itListId,
        returnUrl: '',
      },
    })
    resetQueryParams()
    if (error) {
      console.error(error)
      redirectToItList(itListId, 'Oops, that link is invalid.')
    } else {
      setIsActivated(true)
    }
  }

  useEffect(() => {
    activateItList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { isActivated }
}

const useResetQueryParams = () => {
  const setLocation = useSetLocation()
  return () => {
    setLocation({ search: {}, replaceSearch: true })
  }
}
